// extracted by mini-css-extract-plugin
export default {"heading":"RichNote_heading__NNufj","code":"RichNote_code__oCRZ4","codeblock":"RichNote_codeblock__TdRB6"};